<template>
  <div class="landing-loader-container">
    <div class="landing-spinner"></div>
  </div>
</template>

<script>
export default {
  name: 'LandingLoader'
};
</script>

<style scoped>
.landing-loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 0;
  width: 100%;
}

.landing-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid var(--border-color);
  border-top-color: var(--landing); /* Uses the brand red color */
  border-radius: 50%;
  animation: spin 1s infinite linear;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
